var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOndaGris(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1513,
    height: 285,
    viewBox: "0 0 1513 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00199986 4.07961C238.703 -8.43359 478.857 7.87191 713.792 52.5432C846.473 77.7713 977.568 112.016 1111.31 130.603C1245.05 149.189 1383.22 151.671 1513 113.977V285H0V4.07961H0.00199986Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOndaGris);
export default __webpack_public_path__ + "static/media/onda-gris.0b55992f3ad5d576e1079bba912819a0.svg";
export { ForwardRef as ReactComponent };